/**
 * @description []
 * @date  2016-05-23
 */

import angular from 'angular'
import autoHeightDirective from './autoHeightDirective'

export default angular
    .module('app.autoHeight', [])
    .directive('autoHeight', autoHeightDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/autoHeight/index.js